export enum ActuationTypesGroup {
    PENDING = "PD",
    DOCUMENTAL = "DO",
    POSITION = "PO",
    DO_NOT_POSITION = "NP",
}
